import React from 'react';
import * as Primitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from './utils';
export const Sheet = Primitive.Root;
export const SheetTitle = Primitive.Title;
export const SheetDescription = Primitive.Description;
export const SheetContent = React.forwardRef(({ className, children, ...props }, ref) => <Primitive.Portal>
  <Primitive.Overlay className="pegasus-sheet-overlay" />
  <Primitive.Content ref={ref} className={cn('pegasus-ui pegasus-sheet-content', className)} {...props}>
    {children}
    <Primitive.Close className="pegasus-sheet-close" aria-label="Fermer le menu"><X size={18} /></Primitive.Close>
  </Primitive.Content>
</Primitive.Portal>);
SheetContent.displayName = 'SheetContent';
